import { event_button_click } from '@/utils/gtm';
import Container from '@/components/ui/container';
import ArrowIcon from '@/components/ui/icons/arrow-icon';
import Logo from '../navbar/logo';
import NeedHelpIcon from '@/components/icons/need-help-icon';
import NextLink from '@/components/next-link';
import { useLocale } from 'next-intl';
import { usePathname } from 'next/navigation';
import LocaleSwitcher from '@/components/ui/local-switcher';

const CheckoutHeader = () => {
  const locale = useLocale();
  const pathname = usePathname();

  const backHref = pathname?.includes('/checkout') ? '/cart' : '/';

  return (
    <Container className='grid grid-cols-3 items-center max-lg:max-h-[75px] max-lg:min-h-[75px] max-sm:max-h-[55px] max-sm:min-h-[55px] lg:max-h-22.5 lg:min-h-22.5'>
      <div className='flex items-center gap-2 lg:gap-4'>
        <NextLink
          href={backHref}
          onClick={() =>
            event_button_click({
              button_name: 'Back',
              button_destination: backHref,
              button_location: 'checkout_header',
            })
          }
          className='group flex items-center gap-2 max-sm:gap-0.5'
        >
          <ArrowIcon className='max-lg:size-3 lg:size-4 ltr:rotate-90 rtl:-rotate-90' />
          <span className='group-hover:text-primary underline group-hover:no-underline max-lg:text-sm max-sm:text-xs lg:text-[17px]'>
            {locale === 'en' ? 'Back' : 'رجوع'}
          </span>
        </NextLink>
      </div>

      <div className='flex justify-center'>
        <Logo />
      </div>

      <div className='flex items-center justify-end gap-3 max-sm:gap-1'>
        <LocaleSwitcher />

        <NextLink
          href='/contact-us'
          onClick={() =>
            event_button_click({
              button_name: 'Need Help',
              button_destination: '/contact-us',
              button_location: 'checkout_header',
            })
          }
          className='flex items-center gap-1 sm:gap-3.5 lg:gap-1'
        >
          <NeedHelpIcon className='size-5 lg:size-6' />
          <span className='group-hover:text-primary text-xs group-hover:underline lg:text-[17px]'>
            {locale === 'en' ? 'Need Help?' : 'مساعدة؟'}
          </span>
        </NextLink>
      </div>
    </Container>
  );
};

export default CheckoutHeader;
